import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { Paper, Button, Grid ,TextField} from "@material-ui/core";
import Link from "@material-ui/core/Link";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Popover from "@material-ui/core/Popover";
import Collapse from '@material-ui/core/Collapse';
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ClassMessages from "./ClassMessages";
// REDUX ACTIONS
import { getAllStudentsOfClass } from "../../store/actions/students.action";
import { createPost,getAllPost,getAllPostWithFilter } from "../../store/actions/classfeed.action";

import { getClassInfo,getKneuraId, getShouldTakeAttendanceOption } from "../../utils/authentication-access";
import { withTranslation } from "react-i18next";
import Avatar from "react-avatar";

import {STUDENT} from "../../utils/url-builder";
import BaseService from "../../store/services/base.service";

import classes from "./Students.module.css";

class ClassGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatOpen: false,
      anchorEl: null,
      postText: "",
      firstName: "Staff",
      menuanchorEl: null,
      filterValue: "All",
      errorPostText: "",
      errorPoststatus: false,
      userAddedToClass: false,
      takeAttendance: true,
    };
  }

  async componentDidMount() {
     let isAttendanceTabVisible = getShouldTakeAttendanceOption();
    const isTrueSet = (isAttendanceTabVisible === 'true' || isAttendanceTabVisible===true || !isAttendanceTabVisible);
    this.setState({
     takeAttendance: isTrueSet
    })
    
	const classInfo = getClassInfo();
	const url = STUDENT.getStudentInfo();
    let res = await new BaseService().makeGetRequestGeneric(url);
    this.setState({ firstName: res.data.first_name });
    this.setState({ lastName: res.data.last_name });
    this.setState({ profileImageUrl: res.data.user_photo });
    if(classInfo && classInfo.kneuraId){
    this.setState({userAddedToClass:true})
   	await this.props.getAllStudentsOfClass(classInfo.kneuraId);
    await this.props.getAllPost(classInfo.kneuraId);
    }
  }



  openChat = () => {
    if(this.state.userAddedToClass){
    this.setState({ chatOpen: true,postText:"" });
    this.setState({ errorPoststatus: false ,errorPostText:""});
    }
  };

  closeChat = () => {
    this.setState({ chatOpen: false ,postText:""});
  };

  onPostMessageEnter = (event) =>{
  this.setState({ postText: event.target.value });
  this.setState({ errorPoststatus: false ,errorPostText:""});
  }

  postMessage = async()=>{
  const classInfo = getClassInfo();
  if(this.state.postText === ""){
    this.setState({ errorPoststatus: true ,errorPostText:"Nothing to Share with your class..."});
  }else{
   await this.props.createPost(classInfo.kneuraId,this.state.postText,getKneuraId());
   this.setFilter(this.state.filterValue);
   this.setState({ chatOpen: false });
  }
  }

  openMenu = (event) => {
    if(this.state.userAddedToClass){
    this.setState({ menuanchorEl: event.currentTarget });
    }
	};

	closeMenu = () => {
		this.setState({ menuanchorEl: null });
	};

  setFilter =async(value)=>{
    this.setState({filterValue : value, menuanchorEl: null})
    const classInfo = getClassInfo();
    let startDate = new Date();
    startDate.setHours(0,0,0,0);
    let endDate = new Date();
    if(value == "All"){
      await this.props.getAllPost(classInfo.kneuraId);
    }else if(value == "Today"){
      startDate.setDate(startDate.getDate());
      await this.props.getAllPostWithFilter(classInfo.kneuraId,startDate.toISOString(),endDate.toISOString());
    }else if(value == "Week"){
      startDate.setDate(startDate.getDate() - 7);
      await this.props.getAllPostWithFilter(classInfo.kneuraId,startDate.toISOString(),endDate.toISOString());
    }else if(value == "Month"){
      startDate.setDate(startDate.getDate() - 30);
      await this.props.getAllPostWithFilter(classInfo.kneuraId,startDate.toISOString(),endDate.toISOString());
    }
    
  }
  renderStudentList = () => {
    const { t } = this.props;
    if (!this.state.takeAttendance) {
      return (<></>)
    }
    
    return (
         <Paper className={classes.RightContainer}>
            <div className={classes.TopBar}>
              <div
                className={classes.TopBarHeader}
                style={{ fontSize: "14px" }}
              >
                {t("Students")}
              </div>
             <div></div>
            </div>

            {this.props.classStudentsList && this.props.classStudentsList.length
              ? this.props.classStudentsList.map((student) => (
                  <StudentList studentInfo={student} />
                ))
              : ""}
          </Paper> 
    )
  }
  render() {
    const { t } = this.props;
    return (
      <>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="flex-start"
          className={classes.StudentGrid}
        >
          <Paper className={classes.Container} style={{width:!this.state.takeAttendance?'100%':undefined}}>
            {/* Top Bar */}
            <div className={classes.TopBar}>
              <div className={classes.TopBarHeader}>{t("Class stream")}</div>
              <Button
                style={{ boxShadow: "none" }}
                variant="outlined"
                endIcon={<ArrowDropDownIcon />}
                onClick={this.openMenu}
              >
                {this.state.filterValue}
              </Button>
            </div>
			
			<Collapse in={this.state.chatOpen}>
			 <Paper className={classes.PostTextBox}>
			 <Avatar name={this.state.firstName} src={this.state.profileImageUrl} round={true} size="40" />
			 <TextField
         rowsMax={8}
         multiline
         rows={8}
         variant="outlined"
			   placeholder="Share with your class..."
			   value={this.state.postText}
         onChange={this.onPostMessageEnter}
         helperText={this.state.errorPostText}
         error={this.state.errorPoststatus}
			 />
			 <div></div>
			 <Grid
			   container
			   direction="row"
			   justify="flex-end"
			   alignItems="center"
			 >
			   <Button style={{ marginRight: 10 }} onClick={this.closeChat}>
				 Cancel
			   </Button>
			   <Button variant="contained" color="primary" disableElevation onClick={this.postMessage}>
				 Post
			   </Button>
			 </Grid>
		   </Paper>
		   </Collapse>
		   
		   <Collapse in={!this.state.chatOpen}>
            <Paper
              className={classes.PostButton}
            //   style={{ backgroundColor: "#F2F8FE" }}
              onClick={this.openChat}
            >
              <Avatar
                style={{ justifySelf: "center" }}
                name={this.state.firstName} 
                src={this.state.profileImageUrl}
                round={true}
                size="40"
              />
              <div className={classes.PostButtonText}>
              {this.state.userAddedToClass ?   "+ Share something with your class..." : " Not Added To Any Class"}
              </div>
            </Paper>
			</Collapse>
            {
              this.state.userAddedToClass ? 
       (this.props.posts.length > 0 ? 
           (this.props.posts.map(post => <ClassMessages postinfo={post} firstName={this.state.firstName} profileImageUrl={this.state.profileImageUrl}/> )) :  <div className={classes.noPostText}>Communicate with your class here</div> )
      : <div className={classes.noPostText}>Not Added To Any Class</div> }
          </Paper>
          
          {this.renderStudentList()}
        
        </Grid>
        <Menu
					anchorEl={this.state.menuanchorEl}
					keepMounted
					open={Boolean(this.state.menuanchorEl)}
					onClose={this.closeMenu}
				>
					<MenuItem onClick={() => this.setFilter("All")}>All</MenuItem>
					<MenuItem onClick={() =>this.setFilter("Today")}>Today</MenuItem>
          <MenuItem onClick={() =>this.setFilter("Week")}>Week</MenuItem>
          <MenuItem onClick={() =>this.setFilter("Month")}>Month</MenuItem>
				</Menu>
        </>
    );
  }
}

const mapStateToProps = (state) => {

  const studentsReducer = state.studentsReducer;
  const classFeedReducer = state.classFeedReducer;
  return {
	classStudentsList: studentsReducer.classStudentsList,
    posts: classFeedReducer.posts,
    webView: state.ui.webView,
  };
};

export default connect(mapStateToProps, { getAllStudentsOfClass,createPost,getAllPost,getAllPostWithFilter })(
  withRouter(withTranslation()(ClassGroup))
);

class StudentList extends React.Component {
  render() {
    return (
      <div className={classes.studentListGrid}>
        <Avatar
          name={this.props.studentInfo.firstName}
          round={true}
          size="35"
          src={this.props.studentInfo.profile_url}
        />
        <div className={classes.studentListText}>
          {this.props.studentInfo.firstName +
            " " +
            this.props.studentInfo.lastName}
        </div>
      </div>
    );
  }
}
